import type { FormBuilderBlockIconKey } from './blockIconTypes';
import type { CatalogBlockType } from './catalogSnapshot';

/**
 * Per-block builder icons. `satisfies Record<CatalogBlockType, …>` is the W14 icon
 * half of the CI guard: every server `block_type` must have an icon here, and no
 * stray id may linger. When the backend adds a block, `CATALOG_BLOCK_TYPES` gains
 * it and tsc demands an entry below.
 */
export const FM_BLOCK_ICON_BY_ID = {
  heading: 'Type',
  paragraph: 'AlignLeft',
  rich_text_display: 'FileText',
  text_input: 'Type',
  textarea: 'AlignLeft',
  number_input: 'Hash',
  dropdown: 'ChevronDown',
  radio: 'Circle',
  checkbox: 'CheckSquare',
  checkbox_group: 'CheckSquare',
  date_picker: 'CalendarIcon',
  file_upload: 'Upload',
  signature_pad: 'PenTool',
  section_break: 'Minus',

  patient_first_name: 'Type',
  patient_last_name: 'Type',
  patient_middle_initial: 'Type',
  patient_preferred_name: 'Type',
  patient_title: 'ChevronDown',
  patient_suffix: 'ChevronDown',
  patient_dob: 'CalendarIcon',
  patient_gender: 'ChevronDown',
  patient_language: 'ChevronDown',
  patient_email: 'Type',
  patient_mobile_phone: 'Type',
  patient_home_phone: 'Type',
  patient_work_phone: 'Type',
  patient_contact_method: 'Circle',
  patient_address: 'MapPin',
  patient_marital_status: 'ChevronDown',
  patient_family_size: 'Hash',
  patient_income: 'Hash',
  patient_referral_source: 'Type',
  patient_allergies: 'CheckSquare',
  patient_conditions: 'CheckSquare',
  patient_medications: 'CheckSquare',
  patient_ssn_last4: 'Lock',

  sb_patient_basic_info: 'User',
  sb_contact_details: 'User',
  sb_patient_address: 'User',
  sb_emergency_contact: 'User',
  sb_responsible_party: 'User',
  sb_employer_info: 'User',
  sb_family_status: 'User',
  sb_referral_source: 'User',
  sb_preferred_pharmacy: 'User',
  sb_physician_contact: 'User',
  sb_dental_insurance: 'CreditCard',
  sb_medical_insurance: 'CreditCard',
  sb_insurance_card_upload: 'CreditCard',
  sb_id_card_upload: 'CreditCard',
  sb_sliding_fee: 'CreditCard',
  sb_financial_agreement: 'CreditCard',
  sb_assignment_of_benefits: 'CreditCard',
  sb_medical_history: 'Heart',
  sb_current_medications: 'Heart',
  sb_allergy_list: 'Heart',
  sb_dental_history: 'Heart',
  sb_ai_technology_consent: 'ShieldOutline',
  sb_personalization_authorization: 'ShieldOutline',
  sb_general_consent: 'FileText',
  sb_procedure_consent: 'FileText',
  sb_sedation_consent: 'FileText',
  sb_telehealth_consent: 'FileText',
  sb_photo_video_release: 'FileText',
  sb_refusal_of_treatment: 'FileText',
  sb_hipaa_acknowledgment: 'ShieldOutline',
  sb_release_of_records: 'FileText',
  sb_marketing_consent: 'ShieldOutline',
  sb_patient_signature: 'PenTool',
  sb_guardian_signature: 'PenTool',
  sb_witness_signature: 'PenTool',
  sb_office_policies: 'ShieldOutline',
  sb_patient_rights: 'ShieldOutline',
  sb_communication_preferences: 'ShieldOutline',

  // ELVA operation consents (FD13 §4.5) — locked consent blocks.
  sb_communication_consent: 'ShieldOutline',
  sb_electronic_records_consent: 'ShieldOutline',
  sb_ai_disclosure_consent: 'ShieldOutline',
  sb_data_handling_consent: 'ShieldOutline',
} satisfies Record<CatalogBlockType, FormBuilderBlockIconKey>;
